import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'sts-job-list',
  templateUrl: 'job-list.component.html'
})
export class JobListComponent implements OnInit {
  @Input() jobResults = [];
  @Input() setInfiniteScroll = true;
  @Output() fetchMoreResults: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  moreResults() {    
    return new Promise((resolve) => {
      this.fetchMoreResults.emit(true);
      resolve(true);
     });
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/job-list/job-list.component.ts